import { c as _c } from "react/compiler-runtime";
import { Heading } from '../../../components/Heading';
import { TextLink } from '../../../components/TextLink';
import styles from './ModalContent.module.css';
export type SleepyCoinsInfoText = {
  heading: string;
  description: string;
  learnMore: string;
  learnMoreUrl: string;
};
function SleepyCoinsInfo(t0) {
  const $ = _c(11);
  const {
    text
  } = t0;
  let t1;
  if ($[0] !== text.heading) {
    t1 = <Heading as="h3" level="text-md-important">{text.heading}</Heading>;
    $[0] = text.heading;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== text.learnMore || $[3] !== text.learnMoreUrl) {
    t2 = <TextLink href={text.learnMoreUrl} className={styles.link}>{text.learnMore}</TextLink>;
    $[2] = text.learnMore;
    $[3] = text.learnMoreUrl;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2 || $[6] !== text.description) {
    t3 = <p>{text.description}{" "}{t2}</p>;
    $[5] = t2;
    $[6] = text.description;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <div className={styles.paragraph}>{t1}{t3}</div>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
export default SleepyCoinsInfo;